module.exports = __webpack_public_path__ + "static/media/IMAGE_2-BEE_HIVE_(GETTY)_desktop.08bdc07b.jpg";